export const DECILE_TABLE_DATA = [
    {
        decile: 1,
        quantity: 62,
        importance: 'High',
    },
    {
        decile: 2,
        quantity: 65,
        importance: 'Medium',

    },
    {
        decile: 3,
        quantity: 99,
        importance: 'High',
    },
];

export const SEGMENT_TABLE_DATA = [
    {
        segment: 'Early Adaptor',
        quantity: 35,
        importance: 'Low',
    },
    {
        segment: 'I',
        quantity: 972,
        importance: 'Low',

    },
    {
        segment: 'Infectious Disease Specialist',
        quantity: 20,
        importance: 'High',
    },
];

export const DECILE_TABLE_COLUMNS = [
    {
        key: "decile",
        value: 'Deciles'
    },
    {
        key: "physician_qty",
        value: 'Quantity'
    },
    {
        key: "importance",
        value: 'Select Importance'
    }
];

export const SEGMENT_TABLE_COLUMNS = [
    {
        key: "segment",
        value: 'Segments'
    },
    {
        key: "physician_qty",
        value: 'Quantity'
    },
    {
        key: "importance",
        value: 'Select Importance'
    }
];

export const DUAL_DECILE_TABLE_COLUMNS = [
    {
        key: "client_decile_importance",
        value: 'Rx Potential'
    },
    {
        key: "digital_affinity_importance",
        value: 'Digital Affinity'
    },
    {
        key: "physician_qty",
        value: 'Quantity'
    },
    {
        key: "digital_intensity",
        value: 'Digital Investment'
    },
    {
        key: "promotion_intensity",
        value: 'Personal Promotion Investment'
    },
];

export const DUAL_DECILE_TABLE_DATA = [
    {
        rx_potential: 'High',
        digital_affinity: 'High',
        quantity: 470,
        digital_investment: '$$$',
        personal_promotion_investment: '$$$',
    },
    {
        rx_potential: 'High',
        digital_affinity: 'Medium',
        quantity: 105,
        digital_investment: '$$',
        personal_promotion_investment: '$$',
    },
    {
        rx_potential: 'High',
        digital_affinity: 'Low',
        quantity: 168,
        digital_investment: '$$',
        personal_promotion_investment: '$$',
    },
];

export const importanceOptions = [
    {
        value: "Low",
        label: "Low",
    },
    {
        value: "Medium",
        label: "Medium",
    },
    {
        value: "High",
        label: "High",
    }
];

export const investmentOptions = [
    {
        value: "$",
        label: "$",
    },
    {
        value: "$$",
        label: "$$",
    },
    {
        value: "$$$",
        label: "$$$",
    }
]